export default "__VITE_PUBLIC_ASSET__7445b5d7__"